const localStorageIds = {
  TOKEN: 'accessToken',
  ADDONS: 'addons',
  USER_INITIAL_UNCONFIRMED_EMAIL: 'userInitialUnconfirmedEmail',
  USER_ORG_ROLES: 'userOrgRoles',
  // { [orgId]: ['CanCreateEvent', ...] } from /users/me: what the server allows, per org.
  ORG_PERMISSIONS: 'orgPermissions',
  COMPETITION_PERMISSIONS: 'competitionPermissions',
  SELECTED_ORG: 'selectedOrg',
  SELECTED_TEAM: 'selectedTeam',
  SELECTED_COMPETITION: 'selectedCompetition',
  SELECTED_SEASON: 'selectedSeason',
  SELECTED_STAGE: 'selectedStage',
  SELECTED_GROUP: 'selectedGroup',
  INVITATIONS_SNACK_OPEN: 'invitationsSnackOpen',
  IS_SUPER_ADMIN: 'isSuperAdmin',
  IMPERSONATION: 'impersonation',
  SELECTED_ORG_SUB_STATUS: 'selectedOrgSubStatus',
}

// Selections scoped to the current org/session. SELECTED_ORG feeds the Org-Id
// header on every request, so these must be cleared at every session boundary
// (login, logout, impersonation) — otherwise a new identity inherits the
// previous user's federation and fetches resources it can't access.
export const ORG_SCOPED_LOCAL_STORAGE_KEYS = [
  localStorageIds.SELECTED_ORG,
  localStorageIds.SELECTED_TEAM,
  localStorageIds.SELECTED_COMPETITION,
  localStorageIds.SELECTED_SEASON,
  localStorageIds.SELECTED_STAGE,
  localStorageIds.SELECTED_GROUP,
  localStorageIds.SELECTED_ORG_SUB_STATUS,
]

export default localStorageIds
